import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsList from '../../../components/newsList';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { shopList4 },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip
                    id="260559"
                    type="struct"
                    title="凰家尚品列表3"
                    groupName="凰家尚品"
                    content={shopList4}
                    translate="handleShopStructData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
